import { render } from "./ProductSubtwo.vue?vue&type=template&id=1ff514c7&scoped=true"
import script from "./ProductSubtwo.vue?vue&type=script&lang=js"
export * from "./ProductSubtwo.vue?vue&type=script&lang=js"

import "./ProductSubtwo.vue?vue&type=style&index=0&id=1ff514c7&scoped=true&lang=css"
import "./ProductSubtwo.vue?vue&type=style&index=1&id=1ff514c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff514c7"]])

export default __exports__